var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "Modal2",
        {
          attrs: {
            title: _vm.$t("Mesaj Filtresi Yapılandırması"),
            "ok-text": _vm.okText || _vm.$t("message.save"),
            "cancel-text": _vm.cancelText || _vm.$t("message.cancelText"),
            "show-footer": _vm.showFooter,
            large: "",
          },
          on: { ok: _vm.handleSave, cancel: _vm.handleCancel },
        },
        [
          _c("div", { staticClass: "message-matched-config-form" }, [
            _c("div", { staticClass: "filters-container" }, [
              _c("div", { staticClass: "filter-row" }, [
                _c(
                  "span",
                  { staticClass: "filter-text" },
                  [
                    _c("span", { staticClass: "prefix" }, [_vm._v("Gönderen")]),
                    _vm._v(" "),
                    _c("InlineSelectOperator", {
                      attrs: {
                        options: [{ label: "eşittir", value: "equal" }],
                      },
                      model: {
                        value: _vm.localConfig.authorOperator,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "authorOperator", $$v)
                        },
                        expression: "localConfig.authorOperator",
                      },
                    }),
                    _vm._v(" "),
                    _c("InlineSelectValue", {
                      attrs: {
                        options: _vm.authorOptions,
                        placeholder: "seçin",
                      },
                      model: {
                        value: _vm.localConfig.author,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "author", $$v)
                        },
                        expression: "localConfig.author",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "filter-row" }, [
                _c(
                  "span",
                  { staticClass: "filter-text" },
                  [
                    _c("span", { staticClass: "prefix" }, [
                      _vm._v("Mesaj tipi"),
                    ]),
                    _vm._v(" "),
                    _c("InlineSelectOperator", {
                      attrs: {
                        options: [{ label: "eşittir", value: "equal" }],
                      },
                      model: {
                        value: _vm.localConfig.messageTypeOperator,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "messageTypeOperator", $$v)
                        },
                        expression: "localConfig.messageTypeOperator",
                      },
                    }),
                    _vm._v(" "),
                    _c("InlineSelectValue", {
                      attrs: {
                        options: _vm.messageTypeOptions,
                        placeholder: "seçin",
                      },
                      model: {
                        value: _vm.localConfig.messageType,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "messageType", $$v)
                        },
                        expression: "localConfig.messageType",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "filter-row" }, [
                _c(
                  "span",
                  { staticClass: "filter-text" },
                  [
                    _c("span", { staticClass: "prefix" }, [_vm._v("Platform")]),
                    _vm._v(" "),
                    _c("InlineSelectOperator", {
                      attrs: {
                        options: [{ label: "eşittir", value: "equal" }],
                      },
                      model: {
                        value: _vm.localConfig.platformOperator,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "platformOperator", $$v)
                        },
                        expression: "localConfig.platformOperator",
                      },
                    }),
                    _vm._v(" "),
                    _c("InlineSelectValue", {
                      attrs: {
                        options: _vm.platformOptions,
                        placeholder: "seçin",
                      },
                      model: {
                        value: _vm.localConfig.platform,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "platform", $$v)
                        },
                        expression: "localConfig.platform",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "filter-row" }, [
                _c(
                  "span",
                  { staticClass: "filter-text" },
                  [
                    _c("span", { staticClass: "prefix" }, [_vm._v("Kanallar")]),
                    _vm._v(" "),
                    _c("InlineSelectOperator", {
                      attrs: {
                        options: [
                          { label: "içerir", value: "contain" },
                          { label: "tümü", value: "all" },
                        ],
                      },
                      model: {
                        value: _vm.localConfig.channelsOperator,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig, "channelsOperator", $$v)
                        },
                        expression: "localConfig.channelsOperator",
                      },
                    }),
                    _vm._v(" "),
                    _vm.localConfig.channelsOperator === "contain"
                      ? _c(
                          "span",
                          { staticClass: "multi-value-wrapper" },
                          [
                            _c(
                              "a-select",
                              {
                                staticClass: "multi-select-inline",
                                attrs: {
                                  mode: "multiple",
                                  placeholder: "kanal seçin",
                                },
                                model: {
                                  value: _vm.localConfig.channels,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.localConfig, "channels", $$v)
                                  },
                                  expression: "localConfig.channels",
                                },
                              },
                              _vm._l(_vm.allChannelsForPicker, function (ch) {
                                return _c(
                                  "a-select-option",
                                  { key: ch.value, attrs: { value: ch.value } },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(ch.label) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _c("span", { staticClass: "all-channels-text" }, [
                          _vm._v("tüm kanallar"),
                        ]),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "filter-row" }, [
                _c(
                  "span",
                  { staticClass: "filter-text" },
                  [
                    _c("span", { staticClass: "prefix" }, [
                      _vm._v("Mesaj metni"),
                    ]),
                    _vm._v(" "),
                    _c("InlineSelectOperator", {
                      attrs: { options: _vm.textFilterTypeOptions },
                      model: {
                        value: _vm.localConfig.textFilter.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.localConfig.textFilter, "type", $$v)
                        },
                        expression: "localConfig.textFilter.type",
                      },
                    }),
                    _vm._v(" "),
                    !["empty", "not_empty"].includes(
                      _vm.localConfig.textFilter.type
                    )
                      ? _c("InlineInput", {
                          attrs: { type: "text", placeholder: "metin girin" },
                          model: {
                            value: _vm.localConfig.textFilter.value,
                            callback: function ($$v) {
                              _vm.$set(_vm.localConfig.textFilter, "value", $$v)
                            },
                            expression: "localConfig.textFilter.value",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              !["empty", "not_empty"].includes(_vm.localConfig.textFilter.type)
                ? _c("div", { staticClass: "filter-row" }, [
                    _c(
                      "span",
                      { staticClass: "filter-text" },
                      [
                        _c(
                          "a-checkbox",
                          {
                            model: {
                              value: _vm.localConfig.textFilter.caseSensitive,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.localConfig.textFilter,
                                  "caseSensitive",
                                  $$v
                                )
                              },
                              expression:
                                "localConfig.textFilter.caseSensitive",
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Büyük/küçük harf duyarlı\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "config-info" }, [
              _c("i", { staticClass: "material-icons" }, [_vm._v("info")]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "Bu filtrelere uyan mesajlar geldiğinde otomasyon tetiklenecektir."
                ),
              ]),
            ]),
            _vm._v(" "),
            !_vm.showFooter
              ? _c(
                  "div",
                  {
                    staticClass: "form-actions d-flex gap-5 flex-end",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c("SupsisButton", { on: { click: _vm.handleCancel } }, [
                      _vm._v(
                        _vm._s(_vm.cancelText || _vm.$t("message.cancelText"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      { attrs: { primary: "" }, on: { click: _vm.handleSave } },
                      [_vm._v(_vm._s(_vm.okText || _vm.$t("message.save")))]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }